import { useEffect, useMemo } from "react";
import { useLookup } from "@/hooks";
import {
  buildPromoTypeOptions,
  buildPurchaserOptions,
  buildRetailerOptions,
} from "@/presentation/deduction/components/DeductionFilter/utils/optionBuilders";

const EMPTY_ARRAY: never[] = [];

export const useProgramDetailsOptions = () => {
  const {
    getPurchasersLookup,
    getPromoTypesLookup,
    getRetailersLookup,
    purchasersLookup,
    promoTypesLookup,
    retailersLookup,
  } = useLookup();

  useEffect(() => {
    getPurchasersLookup();
    getPromoTypesLookup();
    getRetailersLookup();
  }, [getPurchasersLookup, getPromoTypesLookup, getRetailersLookup]);

  const purchasersData = purchasersLookup?.data ?? EMPTY_ARRAY;
  const promoTypesData = promoTypesLookup?.data ?? EMPTY_ARRAY;
  const retailersData = retailersLookup?.data ?? EMPTY_ARRAY;

  const purchaserOptions = useMemo(() => buildPurchaserOptions(purchasersData), [purchasersData]);
  const promoTypeOptions = useMemo(() => buildPromoTypeOptions(promoTypesData), [promoTypesData]);
  const retailerOptions = useMemo(() => buildRetailerOptions(retailersData), [retailersData]);

  return {
    purchaserOptions,
    promoTypeOptions,
    retailerOptions,
    isPurchasersLoading: purchasersLookup?.isLoading ?? false,
    isPromoTypesLoading: promoTypesLookup?.isLoading ?? false,
    isRetailersLoading: retailersLookup?.isLoading ?? false,
  };
};
